import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Button from './button';

import i18n from 'app/common/i18n';

class CommonDialog extends Component {
  static propTypes = {
    actions: PropTypes.array,
    open: PropTypes.bool.isRequired
  };

  handleClose = () => this.props.onClose();

  handleSubmit = () => this.props.onSubmit();

  render() {
    const { fullScreen } = this.props;
    const { actions = [], title, open, submitLabel, children } = this.props;

    const dialogActions = [
      ...actions,
      <Button
        key="cancel"
        secondary
        flat
        label={this.props.i18n('Cancel')}
        onClick={this.handleClose}
        style={{ marginLeft: '12px' }}
      />,
      <Button
        key="submit"
        primary
        autoFocus
        label={submitLabel || this.props.i18n('Submit')}
        onClick={this.handleSubmit}
        style={{ marginLeft: '12px' }}
      />
    ];

    return open ? (
      <Dialog
        fullWidth
        fullScreen={fullScreen}
        open={open}
        onClose={this.handleClose}
        className={'dialog-common'}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>{dialogActions}</DialogActions>
      </Dialog>
    ) : null;
  }
}

const CommonDialogI18n = i18n(CommonDialog);

function CommonDialogWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <CommonDialogI18n {...props} fullScreen={fullScreen} />;
}

export default CommonDialogWithMobileDialog;